import React from 'react';
import type { ViewProps } from 'react-native';
import type { AddressType } from '@sweetgreen/garnish';
import { Chip } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationSearchTypePicker = (
  props: LocationSearchTypePickerProps,
) => {
  const { searchType, isDisabled = false, onSelect } = props;
  const { t } = useLocalizationContext();

  return (
    <Chip.Menu
      value={searchType}
      onChange={onSelect as (value: string) => void}
    >
      {LocationSearchTypes.map((addressType) => (
        <Chip
          height={34}
          value={addressType}
          key={addressType}
          disabled={isDisabled}
          accessibilityLabel={t('general.address-type', { addressType })}
          testID={`search-bar.chip.${addressType}`}
        >
          {t('general.address-type', { addressType })}
        </Chip>
      ))}
    </Chip.Menu>
  );
};

// ─────────────────────────────────────────────────────────────────────────────

const LocationSearchTypes: readonly AddressType[] = [
  'pickup',
  'delivery',
  'outpost',
];

// ─── Types ───────────────────────────────────────────────────────────────────

type LocationSearchTypePickerProps = {
  readonly searchType: AddressType;
  readonly isDisabled?: boolean;
  readonly onSelect: (searchType: AddressType) => void;
} & Pick<ViewProps, 'testID'>;
